<a
  [routerLink]="item.route"
  routerLinkActive="bg-brand-500 text-white font-bold shadow-md shadow-brand-500/20"
  [routerLinkActiveOptions]="{ exact: item.route.endsWith('/dashboard') }"
  class="flex items-center gap-3.5 px-4 py-3 rounded-2xl text-[13px] font-semibold text-slate-600 dark:text-slate-400  border border-transparent transition-all group"
>
  <div class="w-5 h-5 flex-shrink-0 group-hover:scale-110 transition-transform flex items-center justify-center">
    <ng-icon [name]="item.icon" size="20"></ng-icon>
  </div>
  {{ item.label }}
  @if (item.badge) {
    <span class="ml-auto bg-brand-500/10 dark:bg-brand-500/20 text-brand-500 dark:text-brand-400 text-[10px] font-bold px-2 py-0.5 rounded-lg">{{ item.badge }}</span>
  }
</a>
